// @flow @jsx h
import { h } from 'preact'
import { Button } from './common/Button'
import style from './Option.css'

import type { Option as OptionType } from '../../types'

type Props = {
  option: OptionType,
  onAnswerClick: Function
}

export const Option = (props: Props) => {
  const { option, onAnswerClick } = props
  return (
    <li class={style.option}>
      <Button onClick={() => onAnswerClick(option.correct)}>
        {option.response}
      </Button>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/Option.js